var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 12 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001D52",
    d: "M6.007 5.667a2.837 2.837 0 0 1-2.834-2.834A2.837 2.837 0 0 1 6.007 0 2.837 2.837 0 0 1 8.84 2.833a2.837 2.837 0 0 1-2.833 2.834m0-4.667a1.835 1.835 0 0 0-1.834 1.833 1.835 1.835 0 0 0 3.667 0A1.835 1.835 0 0 0 6.007 1m2.658 12H3.336c-1.613 0-2.502-.883-2.502-2.487 0-1.774 1.004-3.846 3.833-3.846h2.667c2.83 0 3.833 2.071 3.833 3.846 0 1.604-.888 2.487-2.502 2.487M4.667 7.667c-2.628 0-2.833 2.178-2.833 2.846 0 1.042.45 1.487 1.502 1.487h5.33c1.052 0 1.501-.445 1.501-1.487 0-.668-.204-2.846-2.833-2.846z"
  })));
};
export default SvgUser;